export { useDetails } from './useDetails'
